export class ErrorResponse {

  private _errorCode: string;
  private _errorMessage: string;
  private _errorData: any;
  private _bodyStr;

  private _status: number;

  constructor(status: number, body: any) {
    if ((!status && status !== 0) || !body) {
      throw new Error('Cannot instantiate. Status and body arguments have to be defined');
    }
    this._status = status;
    this._errorCode = body['error'];
    this._errorMessage = body['message'];
    this._errorData = body['errorData'];
    this._bodyStr = JSON.stringify(body);
  }

  public get status(): number {
    return this._status;
  }

  public get errorCode(): string {
    return this._errorCode;
  }

  public get errorMessage(): string {
    return this._errorMessage;
  }

  public get bodyStr() {
    return this._bodyStr;
  }

  public get errorData() {
    return this._errorData;
  }
}
